const FLAG_STORAGE_KEY = "rakazo:review-inbox";

function flag(): string | null {
  try {
    return window.localStorage.getItem(FLAG_STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * The review inbox shows only in development or where someone set the flag rakazo:review-inbox
 * on purpose, until the reviews router is live (RAK-428). Sidebar entry, badge, routes and list
 * all ask this one rule; it stays small so App.tsx can ask it without loading the inbox.
 */
export function reviewInboxEnabled(): boolean {
  return import.meta.env.DEV || flag() !== null;
}

/** Development runs on the mock unless the flag says "rpc"; outside development never. */
export function reviewInboxUsesMock(): boolean {
  return import.meta.env.DEV && flag() !== "rpc";
}
